export default (Error) => {
  return <div>Error PAGE</div>;
};
